import { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';

import { Menus, NavigationTab } from '../types';

import { CompactTabContainer, CompactTabWrapper } from './Tabs.styled';

type CompactTabPros = {
  icon: ReactElement;
  menuOption?: Menus;
  href: string;
  setIsMenuClosed?: NavigationTab['setIsMenuClosed'];
  handleMenuCollapse?: NavigationTab['handleMenuCollapse'];
};

const CompactTab = ({
  handleMenuCollapse,
  setIsMenuClosed,
  menuOption,
  icon,
  href,
}: CompactTabPros) => {
  const handleClick = (menuOption?: Menus) => {
    if (setIsMenuClosed) setIsMenuClosed(false);
    if (handleMenuCollapse && menuOption) handleMenuCollapse(menuOption);
  };

  return (
    <NavLink
      to={href}
      className={({ isActive }) => (isActive ? 'active' : '')}
      onClick={() => handleClick(menuOption)}
    >
      {({ isActive }) => (
        <CompactTabWrapper>
          <CompactTabContainer isActive={isActive}>{icon}</CompactTabContainer>
        </CompactTabWrapper>
      )}
    </NavLink>
  );
};

export default CompactTab;
